import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import SearchIcon from '@mui/icons-material/Search';
import AppBar from "@mui/material/AppBar";
import {styled} from "@mui/material";
import InputBase from "@mui/material/InputBase/InputBase";
import CloseIcon from '@mui/icons-material/Close';
import classesCss from './SearchBar.module.css'

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: '#4D4D4D',
    width: '100%',
    height: '60px',
}));

const SearchBar = ({close, height}) => {
    return (
        <AppBar position="static" sx={{
            backgroundColor: 'white',
        }}>
            <Toolbar variant="dense" sx={{
                height: height,
                display: 'flex',
                alignItems: 'center',
                width: '100%',
            }}>
                <div className={`flex flex-col ${classesCss.searchBar__container}`}>
                    <StyledInputBase
                        placeholder="What can we help you find?"
                        inputProps={{ 'aria-label': 'search' }}/>
                    <span className={classesCss.bottom} id={"top-searchbar-bottom"}/>
                </div>
                <div className={"center flex items-center justify-center"}>
                    <IconButton sx={{
                        marginRight: '10px',
                        marginLeft: '10px'
                    }}>
                        <SearchIcon sx={{
                            fontSize: 30,
                            color: 'orange'
                        }}/>
                    </IconButton>
                    <IconButton sx={{
                        marginRight: '10px',
                        marginLeft: '10px'
                    }} onClick={close}>
                        <CloseIcon sx={{
                            color: 'orange'
                        }}/>
                    </IconButton>
                </div>
            </Toolbar>
        </AppBar>
    );
};

export default SearchBar;
